<style media="screen" type="text/css">
.agent-list-box {
  height: 180px;
  max-height: 180px;
  overflow-y: scroll;
}
</style>
<template>
  <div>
    <v-dialog v-model="dialog.flag" class="br-25" persistent width="520">
      <v-card>
        <!--  close btn -->
        <p class="text-right pr-3" style="margin-bottom: -10px !important">
          <v-icon color="#8F8F8F" small @click="dialog.flag = false">
            mdi-window-close
          </v-icon>
        </p>
        <v-card-text class="flex-column">
          <!--  dialog title -->
          <p class="page-title text-center">
            {{ $lang.ASSIGN_DELIVERY_AGENT.toUpperCase() }}
          </p>

          <div class="mt-4">
            <v-row justify="end">
              <v-col v-if="shipment_line_list" class="pt-0" md="8">
                <p class="sub-title-text">{{ $lang.LINE }}</p>
                <p class="sub-title-text">
                  {{ line_name }}
                </p>
              </v-col>
              <v-col v-if="total_packets" class="pt-0" md="4">
                <div class="d-flex flex-row pt-0 flex-row-reverse" flat>
                  <div class="pa-2" flat>
                    <p class="secodry-text-2">{{ $lang.PACKAGES }}</p>
                    <p class="sub-title-text text-center">
                      {{ total_packets }}
                    </p>
                  </div>
                  <div>
                    <img
                        alt="img"
                        class="mt-5"
                        src="@/assets/drawer/shipment-active.svg"
                        width="25px"
                    />
                  </div>
                </div>
              </v-col>

              <v-col class="pt-0" md="12">
                <p class="sub-title-text-dark mb-2">
                  {{ $lang.SELECT_DELIVERY_AGENT }}
                </p>

                <v-text-field
                    v-model="search_query"
                    :label="$lang.SEARCH"
                    :loading="search_loading"
                    append-icon="mdi-magnify"
                    dense
                    outlined
                    rounded
                    single-line
                    @keyup="getDeliveryAgents"
                ></v-text-field>

                <div class="agent-list-box">
                  <v-checkbox
                      v-for="delivery_agent in delivery_agent_list"
                      :key="delivery_agent.id"
                      v-model="delivery_agent_id_list"
                      :disabled="!delivery_agent.is_available"
                      :label="delivery_agent.delivery_agent_name"
                      :value="delivery_agent.id"
                      class="ml-2 mt-0 custome-checkbox"
                      @change="singleSelect(delivery_agent)"
                  >
                    <template v-slot:label>
                      <div>
                        <p class="sub-title-text-dark">
                          <v-badge
                              :color="
                              delivery_agent.is_available
                                ? 'primary'
                                : 'rgb(255, 113, 113)'
                            "
                              :content="
                              delivery_agent.today_count
                                ? delivery_agent.today_count.toString()
                                : '0'
                            "
                              bordered
                              overlap
                          >
                            <span class="pr-3">
                              {{ delivery_agent.agent_name }}
                            </span>
                          </v-badge>
                        </p>
                        <p class="select-secondary-text">
                          {{ delivery_agent.agent_phone_number }}
                        </p>
                      </div>
                    </template>
                  </v-checkbox>
                </div>
              </v-col>
            </v-row>
          </div>
          <div class="text-center mt-4">
            <v-btn
                :disabled="delivery_agent_id_list.length == 0 ? true : false"
                :loading="btn_loading"
                class="fw-bold ml-5"
                color="primary"
                @click="dispatchShipment()"
            >
              {{ $lang.ASSIGN }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

export default {
  props: ["dialog", "total_packets", "shipment_id_list", "trip_id", 'shipment_line_list'],
  data() {
    return {
      delivery_agent_list: [],
      delivery_agent_id_list: [],
      delivery_agent: {},
      search_query: "",
      search_loading: false,
      btn_loading: false,
      cancel_token: null,
    };
  },
  computed: {
    line_name() {

      return this.shipment_line_list.join(", ")
    }
  },
  created() {
    this.getDeliveryAgents();
  },
  methods: {
    /* fetching the list of deliverry agents*/
    getDeliveryAgents() {

      const self = this;
      self.search_loading = true;
      self.filter_agent_type = status;
      let params = {
        page_number: this.page_number,
        page_length: this.$keys.PAGE_LENGTH,
        search_query: this.search_query,
        filter_agent_type: JSON.stringify([self.$keys.DELIVERY_AGENT]),
        is_active: 'yes',
      };
      const successHandler = (response) => {
        if (response.data.success)
          self.delivery_agent_list = response.data.agent_list;
      };
      const finallyHandler = () => {
        self.search_loading = false;
      };
      self.request_GET(
          self,
          self.$urls.AGENT_LIST,
          params,
          successHandler,
          null,
          null,
          finallyHandler, true
      );
    },
    singleSelect(delivery_agent) {
      this.delivery_agent = delivery_agent;
      this.delivery_agent_id_list = [];
      this.delivery_agent_id_list.push(delivery_agent.id);
    },

    /* assign delivery agen and dispatch shiments*/
    dispatchShipment() {
      const self = this;
      this.btn_loading = true;

      var form = new FormData();
      let url = self.$urls.DISPATCH_SHIPMENT;
      if (self.trip_id) url = self.$urls.REASSIGN_TRIP;

      if (self.trip_id) {
        form.append("trip_id", self.trip_id);
      } else {
        form.append("shipment_id_list", JSON.stringify(self.shipment_id_list));
      }
      form.append("delivery_agent_id", self.delivery_agent_id_list[0]);

      const successHandler = (response) => {
        if (response.data.success) {
          this.dialog.flag = false;
          this.$emit("update-data", self.delivery_agent);
        }
      };
      const finallyHandler = () => {
        this.btn_loading = false;
      };

      this.request_POST(
          self,
          url,
          form,
          successHandler,
          null,
          null,
          finallyHandler
      );
    },
  },
};
</script>